import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import WarningModal from 'shared/lib/components/modals/warningModal';
import { SectionModel } from 'entities/section/model/sectionModel';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'shared/lib/components/modals/modal';
import { MobxContext } from 'shared/lib/contexts/mobxContext';

export type DeleteSectionModalControllerActions = {
  afterSectionDelete?: (sectionModel: SectionModel) => void;
};

export default observer(function DeleteSectionModalController({
  section,
  afterSectionDelete,
  handleClose,
}: {
  section: SectionModel;
} & DeleteSectionModalControllerActions & {
    handleClose: ModalProps['handleClose'];
  }) {
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  return (
    <>
      <WarningModal
        mainText={t('warnings.delete.sectionMain')}
        secondText={t('warnings.delete.sectionSecond')}
        isOpen={true}
        onCancel={handleClose}
        onContinue={async () => {
          try {
            await section.delete();
            afterSectionDelete && afterSectionDelete(section);
            handleClose();
          } catch (e) {
            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
            console.error(e);
            handleClose();
          }
        }}
      ></WarningModal>
    </>
  );
});
